import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  // eslint-disable-next-line
  selector: 'wsb-atlas-step',
  styleUrls: ['atlas-step.component.scss'],
  templateUrl: 'atlas-step.component.html',
  standalone: false
})
export class AtlasStepComponent implements OnInit {
  @Input() public numSteps;
  @Input() public currentStep;
  @Input() public routeStep;
  public numbers;
  public stepsPositions;
  public lineWidth;
  constructor(private router: Router) {}
  // public labels;
  ngOnInit() {
    this.numbers = Array(this.numSteps)
      .fill(1)
      .map((x, i) => i + 1);
    this.stepsPositions = this.numbers.map(x => {
      return Math.round((100 / (this.numSteps - 1)) * (x - 1));
    });
    this.lineWidth = Math.round(100 / (this.numSteps - 1));
  }

  navigateOnClickStep(step) {
    if (this.routeStep[step]) {
      this.router.navigate([this.routeStep[step]]);
    }
  }
}
